import classNames from 'classnames';

function Badge({ children, className, isCustom = false, ...props }) {
  return (
    <span
      className={classNames({ ['badge']: !isCustom }, className)}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
